import { useContext, useMemo } from 'react';
import { environmentContext } from '../environmentContext';
export const useEnvironmentConfiguration = () => {
  const {
    environment,
    tenant
  } = useContext(environmentContext);
  return useMemo(() => ({
    environment,
    tenant
  }), [environment, tenant]);
};
//# sourceMappingURL=useEnvironmentConfiguration.js.map